import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { audio } from "./audio";

// ?mute=1 silences music + effects (automated tests, quiet previews).
if (new URLSearchParams(location.search).has("mute")) audio.setMuted(true);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
